/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Meta_Starter_SubtitleInputs */



/**
* | output |
* | --- |
* | "For compliance leads flying solo" |
*
* @param {Plan_Meta_Starter_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_meta_starter_subtitle = /** @type {((inputs?: Plan_Meta_Starter_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Meta_Starter_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für Compliance-Verantwortliche")
	return /** @type {LocalizedString} */ ("For compliance leads flying solo")
});